export default "__VITE_ASSET__a6b88c04__"